export default "__VITE_ASSET__CxfE_S5S__"